function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgHospitality = function SvgHospitality(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 505.60699462890625 505.60699462890625",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Layer_1_1565755140531",
    width: 70,
    height: 67,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M494.213,234.016h-58.754v-16.787c0-5.036-3.357-8.393-8.393-8.393v-16.787c5.036,0,8.393-3.357,8.393-8.393     c0-32.734-26.02-58.754-58.754-58.754s-58.754,26.02-58.754,58.754c0,5.036,3.357,8.393,8.393,8.393v16.787     c-5.036,0-8.393,3.357-8.393,8.393v16.787h-99.882v-50.361c0-24.341-11.751-47.003-31.895-61.272     c-3.357-1.679-7.554-1.679-10.072,0c-20.144,14.269-47.843,14.269-67.987,0c-3.357-1.679-7.554-1.679-10.072,0     c-20.144,14.269-31.895,36.931-31.895,61.272v50.361H7.393c-5.036,0-8.393,3.357-8.393,8.393v50.361     c0,5.036,3.357,8.393,8.393,8.393v176.262c0,14.269,10.911,25.18,25.18,25.18h436.459c14.269,0,25.18-10.911,25.18-25.18V301.164     c5.036,0,8.393-3.357,8.393-8.393V242.41C502.607,237.374,499.249,234.016,494.213,234.016z M376.705,141.689     c20.144,0,36.931,14.269,41.128,33.574h-82.256C339.774,155.957,356.561,141.689,376.705,141.689z M343.131,192.049h67.148     v16.787h-67.148V192.049z M334.738,225.623h83.934v8.393h-83.934V225.623z M141.689,153.439l14.269,15.108l-14.269,24.341     l-14.269-24.341L141.689,153.439z M82.934,183.656c0-16.787,7.554-32.734,20.144-44.485c6.514,3.955,13.545,6.809,20.805,8.572     l-13.251,13.251c-3.357,2.518-3.357,6.715-1.679,10.072l25.18,41.967c1.679,2.518,4.197,4.197,7.554,4.197     s5.875-1.679,7.554-4.197l25.18-41.967c1.679-3.357,0.839-7.554-1.679-10.072l-13.251-13.251     c7.26-1.763,14.291-4.617,20.805-8.572c12.59,11.751,20.144,27.698,20.144,44.485v50.361H82.934V183.656z M15.787,250.803h58.754     h134.295h117.508h100.721h58.754v33.574H15.787V250.803z M477.426,418.672h-50.361c-5.036,0-8.393,3.357-8.393,8.393     c0,5.036,3.357,8.393,8.393,8.393h50.361v16.787h-50.361c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h50.361v8.393     c0,5.036-3.357,8.393-8.393,8.393H32.574c-5.036,0-8.393-3.357-8.393-8.393v-8.393h50.361c5.036,0,8.393-3.357,8.393-8.393     s-3.357-8.393-8.393-8.393H24.18v-16.787h50.361c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393H24.18V301.164     h453.246V418.672z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.689,116.508c32.734,0,58.754-26.02,58.754-58.754C200.443,25.02,174.423-1,141.689-1S82.934,25.02,82.934,57.754     C82.934,90.489,108.954,116.508,141.689,116.508z M141.689,15.787c23.502,0,41.967,18.466,41.967,41.967     s-18.466,41.967-41.967,41.967S99.721,81.256,99.721,57.754C99.721,34.252,118.187,15.787,141.689,15.787z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,469.033c41.967,0,75.541-33.574,75.541-75.541c0-41.967-33.574-75.541-75.541-75.541     s-75.541,33.574-75.541,75.541C166.869,435.459,200.443,469.033,242.41,469.033z M242.41,334.738     c32.734,0,58.754,26.02,58.754,58.754s-26.02,58.754-58.754,58.754s-58.754-26.02-58.754-58.754S209.675,334.738,242.41,334.738z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,435.459c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393c-14.269,0-25.18-10.911-25.18-25.18     c0-5.036-3.357-8.393-8.393-8.393s-8.393,3.357-8.393,8.393C200.443,416.993,218.908,435.459,242.41,435.459z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,368.311c14.269,0,25.18,10.911,25.18,25.18c0,5.036,3.357,8.393,8.393,8.393s8.393-3.357,8.393-8.393     c0-23.502-18.466-41.967-41.967-41.967c-5.036,0-8.393,3.357-8.393,8.393S237.374,368.311,242.41,368.311z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHospitality, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hospitality.6ab58e51.svg";
export { ForwardRef as ReactComponent };